import { apiConfig } from "./apiConfig";

export const urlUserValidate = apiConfig.user.validate;

export const userValidate = (axios, vals) => axios.post(`${urlUserValidate}`, vals);
